import createAttachmentsFromRecentAttachments from './AttachmentQueueManager/createAttachmentsFromRecentAttachments';
import datapoints from '../datapoints';
import { logUsage } from 'owa-analytics';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-mail-strings';
import { InfoBarMessageSource, } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
export var INCLUDE_MOST_RECENT_ATTACHMENTS_MESSAGEID = 'InfoIncludeMostRecentAttachmentsMessage';
export function includeMostRecentAttachmentsInfoBarMessage(itemId, message, attachmentWell, recipients, recipientNameAdded, numberOfAddedRecipients, infoBarAddHandler, infoBarRemoveHandler, updateActedComposeCallback) {
    var infoBarMessageViewState = {
        key: INCLUDE_MOST_RECENT_ATTACHMENTS_MESSAGEID,
        source: InfoBarMessageSource.Compose,
        rank: null,
        messageParts: [
            getAddedRecipientAttachmentsInfoBarString(numberOfAddedRecipients, recipientNameAdded),
        ],
    };
    infoBarMessageViewState.messageParts.push(getIncludeMostRecentAttachmentsInfoBarAction(itemId, attachmentWell, message, infoBarAddHandler, infoBarRemoveHandler, updateActedComposeCallback));
    infoBarMessageViewState.messageParts.push('|');
    infoBarMessageViewState.messageParts.push(getDoNotIncludeMostRecentAttachmentsInfoBarAction(infoBarRemoveHandler, updateActedComposeCallback));
    infoBarAddHandler(INCLUDE_MOST_RECENT_ATTACHMENTS_MESSAGEID, function () { return infoBarMessageViewState; });
}
function getDoNotIncludeMostRecentAttachmentsInfoBarAction(infoBarRemoveHandler, updateActedComposeCallback) {
    return {
        text: strings.DontIncludeMostRecentAttachments,
        action: function () {
            updateActedComposeCallback();
            infoBarRemoveHandler([INCLUDE_MOST_RECENT_ATTACHMENTS_MESSAGEID]);
            logUsage(datapoints.AttachmentDoNotIncludeMostRecentAttachments.datapoint.name);
        },
    };
}
function getAddedRecipientAttachmentsInfoBarString(numberOfAddedRecipients, recipientNameAdded) {
    var recipientAddedNotificatioMessage = numberOfAddedRecipients > 1
        ? format(strings.IncludeMostRecentAttachmentAddedRecipient_MultipleRecipientsText, numberOfAddedRecipients)
        : format(strings.IncludeMostRecentAttachmentAddedRecipient_SingleRecipientText, recipientNameAdded);
    return recipientAddedNotificatioMessage;
}
function getIncludeMostRecentAttachmentsInfoBarAction(itemId, attachmentWell, message, infoBarAddHandler, infoBarRemoveHandler, updateActedComposeCallback) {
    var includeMostRecentAttachmentMessage = message.Attachments.length > 1
        ? strings.SuggestIncludeMostRecentAttachment_MultipleAttachmentsText
        : strings.SuggestIncludeMostRecentAttachment_SingleAttachmentText;
    return {
        text: includeMostRecentAttachmentMessage,
        action: function () {
            updateActedComposeCallback();
            logUsage(datapoints.AttachmentIncludeMostRecentAttachments.datapoint.name);
            createAttachmentsFromRecentAttachments(itemId, attachmentWell, message.Attachments, infoBarAddHandler, infoBarRemoveHandler);
        },
    };
}
//# sourceMappingURL=includeMostRecentAttachmentsInfoBarMessage.js.map